<app-card height="100%">
    <ng-template #header>
        <div class="flex align-items-center gap">
            <app-avatar
                size="large"
                [person]="candidate().person"
            ></app-avatar>
            <div class="font-bold">{{ candidate().person | formatPerson }}</div>
        </div>
    </ng-template>

    <ng-template #content>
        <div class="grid grid-2col input-grid-gaps p-2">
            <app-date-input
                [formField]="formDef.timeFrom"
                [timeOnly]="true"
                label="attendance.fields.timeFrom"
            ></app-date-input>
            <app-date-input
                [formField]="formDef.timeTo"
                [timeOnly]="true"
                label="attendance.fields.timeTo"
            ></app-date-input>

            <app-text-input
                [formField]="formDef.note"
                label="attendance.fields.note"
                class="fr-2"
            ></app-text-input>

            <app-button
                label="attendance.daily.confirm"
                icon="pi-check"
                severity="success"
                styleClass="w-full"
                [disabled]="formDef().invalid()"
                (clickEvent)="confirm()"
            ></app-button>
            <app-button
                label="attendance.daily.checkout"
                icon="pi-times"
                severity="danger"
                styleClass="w-full"
                (clickEvent)="checkout.emit(candidate())"
            ></app-button>
        </div>
    </ng-template>

</app-card>
